<template>
  <div class="public-visa-check-container">
    <v-card class="login-card" v-if="!Object.keys(visa_detail).length">
      <v-card-text class="pa-0">
        <top-header-section text-item="Visa Check" :header-logo="logoUrl"/>
        <v-form lazy-validation ref="form" v-model="valid">
          <v-layout column wrap>
            <form-error-display-handler :errors="errors"/>
            <v-flex xs 12>
              <v-autocomplete
                  :clearable="true"
                  :items="countries"
                  label="Select Country *"
                  :rules="[rules.required]"
                  item-text="country_name"
                  item-value="id"
                  outlined
                  v-model="nationalitySelected"
                  id="selectCountry"
              />
            </v-flex>
            <v-flex xs12>
              <v-text-field
                  :rules="[rules.required]"
                  label="Visa number"
                  outlined
                  prepend-inner-icon="mdi-alpha-s-box"
                  type="text"
                  v-model="visa_number"
              />
            </v-flex>

            <v-flex xs12>
              <v-text-field
                  :rules="[rules.required]"
                  label="Passport number"
                  outlined
                  prepend-inner-icon="mdi-passport"
                  type="text"
                  v-model="passport_number"
              />
            </v-flex>
            <v-flex xs7>
              <!--              <v-text-field-->
              <!--                  :label="$vuetify.lang.t('$vuetify.dob')+' *'"-->
              <!--                  :rules="[rules.required,rules.dobValidityDate]"-->
              <!--                  outlined-->
              <!--                  type="date"-->
              <!--                  v-model="dob"-->
              <!--                  id="dob"-->
              <!--              />-->
              <date-picker-new
                  class="px-2"
                  style="max-width: 400px;"
                  :label="$vuetify.lang.t('$vuetify.dob_day')+ ' *'"
                  v-model="dob"
                  :min-year="dateOfBirth.min_year"
                  :max-year="dateOfBirth.max_year"
              />
            </v-flex>
            <v-flex xs12 class="px-3 text-center">
              <v-layout row wrap>
                <v-flex xs12 class="pl-2">
                  <v-btn
                      :loading="visaLoading"
                      @click="checkVisa"
                      class="white--text"
                      color="primary"
                  >Search Visa
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-form>
      </v-card-text>
    </v-card>
    <v-card class="login-card" v-if="Object.keys(visa_detail).length > 0">
      <v-card-text class="pa-0">
        <v-layout column wrap class="">
          <top-header-section text-item="Visa Information" :header-logo="logoUrl"/>
          <v-layout>
            <v-flex xs6>
              <list-item-detail
                  :show-tooltip="true"
                  :sub_title="visa_detail.name"
                  title="Full Name"/>
            </v-flex>
            <v-flex xs6>
              <list-item-detail
                  :show-tooltip="true"
                  :sub_title="visa_detail.passport_number"
                  title="Passport Number"/>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex xs6>
              <list-item-detail
                  :sub_title="visa_detail.validity"
                  title="Passport Validity"/>
            </v-flex>
            <v-flex xs6>
              <list-item-detail
                  :show-tooltip="true"
                  :sub_title="visa_detail.type"
                  title="Visa Type"/>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex xs6>
              <list-item-detail
                  :show-tooltip="true"
                  :sub_title="visa_detail.visa_number"
                  title="Visa Number"/>
            </v-flex>
            <v-flex xs6 v-if="visa_detail.issued_officer">
              <list-item-detail
                  :show-tooltip="true"
                  :sub_title="visa_detail.issued_officer"
                  title="Issued By"/>
            </v-flex>
          </v-layout>
          <v-flex xs12 v-if="visa_detail.start_date">
            <list-item-detail
                :show-tooltip="true"
                :sub_title="visa_detail.start_date+' to '+visa_detail.expiry_date"
                title="Visa Period"/>
          </v-flex>
        </v-layout>
        <v-flex xs12 class="px-3 text-center">
          <v-layout row wrap>
            <v-flex xs12 class="pl-2">
              <v-btn
                  :loading="visaLoading"
                  @click="resetHistory"
                  class="white--text"
                  color="success"
              >
                <v-icon>mdi-tick</v-icon>
                Done
              </v-btn>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import {validationMixin} from "../mixins/validationMixin";
import FormErrorDisplayHandler from "../components/FormErrorDisplayHandler";
import {NEPAL_SARKAR_LOGO, NEPALIPORT_LOGO_URL} from "../constant/appConstant";
import ListItemDetail from "../components/ListItemDetail"
import TopHeaderSection from "../components/TopHeaderSection";
import DatePickerNew from "../components/DatePickerNew"


export default {
  components: {
    FormErrorDisplayHandler, ListItemDetail, TopHeaderSection, DatePickerNew
  },
  mixins: [validationMixin],
  data() {
    return {
      nationalitySelected: '',
      valid: false,
      logoUrl: NEPALIPORT_LOGO_URL,
      sarkarLogo: NEPAL_SARKAR_LOGO,
      dob: "",
      passport_number: "",
      visa_number: "",
      errors: [],
      visa_detail: {},
      visaLoading: false,
    };
  },
  computed: {
    ...mapGetters({
      countries: 'CountryForTouristList/all',
    }),
    dateOfBirth() {
      const max_year = parseInt(new Date().toISOString().substr(0, 4));
      const min_year = parseInt(max_year) - 120;
      return {
        min_year,
        max_year
      }
    },
  },
  methods: {
    ...mapActions({
      fetchAllNationalities: "CountryForTouristList/fetchAll",
      searchForVisa: "VisaSingle/checkVisaInfo"
    }),
    checkVisa() {
      this.visa_detail = {};
      if (this.$refs.form.validate()) {
        this.visaLoading = true;
        this.errors = [];

        this.searchForVisa({
          dob: this.dob,
          passport_number: this.passport_number,
          country: this.nationalitySelected,
          visa_number: this.visa_number,
        })
            .then((res) => {
              this.visa_detail = res.visa_detail;
              this.visaLoading = false;
            })
            .catch((err) => {
              this.errors.push(err.response.data.message);
              this.visaLoading = false;
            })
      }
    },
    resetHistory() {
      location.reload();
    }
  },
  async mounted() {
    this.fetchAllNationalities();
  }
}
;
</script>

<style scoped>
.login-card {
  border-radius: 4px;
  padding-left: 45px !important;
  padding-right: 45px !important;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}
</style>
